import { useQuery } from '@apollo/client/react';
import { useStorePubSub } from '@drycut/apollo';
import { BookingCheckout } from '@drycut/booking-components';
import { useScheduledRefresh } from '@drycut/controlled-components';
import { type CompleteStoreFragment, GetStoreDocument, type Maybe } from '@drycut/graphql';
import { Heading, Loader, Stack } from '@drycut/ui-components';
import { useNavigate, useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

import { Container } from '../components';

export function NewBooking(): React.ReactNode {
  useDocumentTitle('DRYCUT - Book');

  const { slug } = useParams() as { slug: string };
  const { data, loading } = useQuery(GetStoreDocument, { variables: { slug } });
  const navigate = useNavigate();

  // Refresh the screen at midnight and noon to ensure that the content is always up to date.
  useScheduledRefresh([
    { hour: 20 }, // 8pm, to ensure that the schedule for the next day is always up to date
    { hour: 0 }, // midnight (for new deployments)
  ]);

  const store: Maybe<CompleteStoreFragment> = data?.store || null;

  // Real time updates for the waiting time and stylist list.
  useStorePubSub({ slug });

  if (loading) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }

  if (!store || !store.active) {
    navigate('/not-found');
    return null;
  }

  return (
    <Stack className="grow justify-center w-full">
      <Heading>right hair. right now.</Heading>
      {/* The checkout is the one screen that needs the full width */}
      <Container wrapperClassName="max-w-none w-auto">
        <BookingCheckout storeSlug={slug} manual />
      </Container>
    </Stack>
  );
}
